(function () {
  'use strict';
  function parseMoney(text) {
    var normalized = String(text || '').replace(/[^0-9]/g, '');
    var cents = parseInt(normalized, 10);
    return Number.isFinite(cents) ? cents : null;
  }
  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      var formatNode = document.querySelector('[data-section-type="static-cart"]');
      try {
        var data = JSON.parse(formatNode.textContent || '{}');
        return window.Shopify.formatMoney(cents, data.settings.money_format);
      } catch (error) {}
    }
    return '£' + (cents / 100).toFixed(2);
  }
  function syncTotals(root) {
    var ex = root.querySelector('[data-smcart-ex-total]');
    var vat = root.querySelector('[data-smcart-vat-total]');
    var inc = root.querySelector('[data-smcart-inc-total]');
    if (!ex || !vat || !inc) return;
    var exCents = parseMoney(ex.textContent);
    if (exCents === null) return;
    vat.textContent = formatMoney(Math.round(exCents * 0.20));
    inc.textContent = formatMoney(Math.round(exCents * 1.20));
  }
  function initMobileCheckout(root) {
    var bar = root.querySelector('[data-smcart-mobile-checkout]');
    var button = root.querySelector('[data-smcart-mobile-checkout-button]');
    var mobileTotal = root.querySelector('[data-smcart-mobile-total]');
    var mainCheckout = root.querySelector('[data-smcart-main-checkout]');
    var incTotal = root.querySelector('[data-smcart-inc-total]');
    if (!bar || !button || !mainCheckout) return;

    function syncMobileTotal() {
      if (mobileTotal && incTotal) mobileTotal.textContent = incTotal.textContent;
    }

    function setVisible(visible) {
      bar.hidden = !visible;
    }

    button.addEventListener('click', function () {
      mainCheckout.click();
    });

    syncMobileTotal();
    if (incTotal) {
      new MutationObserver(syncMobileTotal).observe(incTotal, { childList:true, characterData:true, subtree:true });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        var visible = entries.some(function (entry) { return entry.isIntersecting; });
        setVisible(!visible);
      }, { root:null, threshold:0.12 });
      observer.observe(mainCheckout);
    } else {
      function fallback() {
        var rect = mainCheckout.getBoundingClientRect();
        var visible = rect.top < window.innerHeight && rect.bottom > 0;
        setVisible(!visible);
      }
      fallback();
      window.addEventListener('scroll', fallback, { passive:true });
      window.addEventListener('resize', fallback);
    }

    window.addEventListener('resize', function () {
      var rect = mainCheckout.getBoundingClientRect();
      var visible = rect.top < window.innerHeight && rect.bottom > 0;
      setVisible(!visible);
    });
  }

  function init(root) {
    if (!root || root.dataset.smcartReady === 'true') return;
    root.dataset.smcartReady = 'true';
    syncTotals(root);
    var ex = root.querySelector('[data-smcart-ex-total]');
    if (ex) {
      new MutationObserver(function () { syncTotals(root); }).observe(ex, { childList:true, characterData:true, subtree:true });
    }
    initMobileCheckout(root);
  }
  function boot() { document.querySelectorAll('[data-smcart-root]').forEach(init); }
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
